import { useEffect, useState } from 'react';
import { startOfDay } from 'date-fns';

import { getRequestedRidesExistence } from '../../../api/services/Riders';

interface IUseRequestedRides {
  hasRideRequests: boolean;
}

export const useRequestedRides = (id: string): IUseRequestedRides => {
  const [hasRideRequests, setHasRideRequests] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    const fetchRequestedRides = async () => {
      const response = await getRequestedRidesExistence(
        id,
        { state: 'requested', fromDate: startOfDay(new Date()) },
        abortController.signal
      );

      if (abortController.signal.aborted) {
        return;
      }

      if (response?.type === 'success') {
        setHasRideRequests(response.data.criteriaMatched);
      }
    };

    fetchRequestedRides();

    return () => abortController.abort();
  }, []);

  return { hasRideRequests };
};
